import React, { useState } from "react";
import ProgramsHierarchy from "@/shared/components/ProgramsHierarchy";
import { connect } from "react-redux";
import Select from "react-select";
import { Button, Col, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import { CSVLink } from "react-csv";
import { getFirstDay } from "@/shared/helpers";
import { dateStrToYmd } from "@/shared/helpers";
import { isEqual, clone, cloneDeep } from "lodash";
import { formatCurrency } from "@/shared/helpers";

const defaultFrom = getFirstDay();
const defaultTo = new Date();

const sourceOptions = [
  { label: 'All', value: '' },
  { label: "Approved Reject", value: "ApprovedRejectNotification" },
  { label: "Award", value: "AwardNotification" },
  { label: "Cron", value: "CronNotification" },
  { label: "Invitation Accepted", value: "InvitationAcceptedNotification" },
  { label: "Monthly Invoice", value: "MonthlyInvoiceNotification" },
  { label: "Organization Program Created", value: "OrganizationProgramCreated" },
  { label: "Add Participant", value: "ParticipantAddedNotifyUser" },
  { label: "Referral", value: "ReferralNotification" },
  { label: "Reset Password", value: "ResetPasswordNotification" },
  { label: "Tango Order Error", value: "TangoOrderErrorNotification" },
  { label: "User Invited Notify Admin", value: "UserInvitedNotifyAdmin" },
  { label: "User Invited Notify User", value: "UserInvitedNotifyUser" },
  { label: "Verification Code", value: "VerificationCodeNotification" },
];

const appTypeOptions = [
  { label: 'All', value: '' },
  { label: "Program", value: "Program" },
  { label: "App", value: "App" },
  { label: "CLI", value: "CLI" },
];

const typeOptions = [
  { label: 'All', value: '' },
  { label: "PHP Mailer", value: "PHP Mailer" },
];

const statusOptions = [
  { label: 'All', value: '' },
  { label: "Success", value: "Success" },
  { label: "Error", value: "Error" },
];

const EmailLogsFilter = ({
  filter,
  setFilter,
  setUseFilter,
  download,
  exportData,
  exportLink,
  exportHeaders,
  config
}) => {
  const defaultConfig = {
    dateRange: true,
    programs: true,
    exportToCsv: true,
    source: true,
    app: true,
    status: true,
    type: true,
    keyword: true,
  };

  const options = { ...defaultConfig, ...config }

  const [from, setFrom] = React.useState(defaultFrom);
  const [keyword, setKeyword] = React.useState("");
  const [to, setTo] = React.useState(defaultTo);
  const [source, setSource] = useState(sourceOptions[0]);
  const [app, setApp] = useState(appTypeOptions[0]);
  const [type, setType] = useState(typeOptions[0]);
  const [status, setStatus] = useState(statusOptions[0]);
  const [selectedPrograms, setSelectedPrograms] = useState(
    filter.programs ? filter.programs : []
  );
  const finalFilter = { ...filter };
  let previous = cloneDeep(finalFilter);


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onClickFilter();
    }
  };

  const onClickFilter = (reset = false, exportToCsv = 0) => {
    let dataSet = {};
    if (options.dateRange) {
      dataSet.from = dateStrToYmd(reset ? defaultFrom : from);
      dataSet.to = dateStrToYmd(reset ? defaultTo : to);
    }
    if (options.programs) {
      dataSet.programs = reset ? [] : clone(selectedPrograms);
    }
    if (options.keyword) {
      dataSet.keyword = reset ? '' : keyword;
    }
    if (options.source) {
      dataSet.source = reset ? '' : source.value;
    }
    if (options.app) {
      dataSet.app = reset ? '' : app.value;
    }
    if (options.status) {
      dataSet.status = reset ? '' : status.value;
    }
    if (options.type) {
      dataSet.type = reset ? '' : type.value;
    }
    onClickFilterCallback(dataSet);
    previous = dataSet;
    if (reset) {
      setFrom(defaultFrom);
      setTo(defaultTo);
      setKeyword('');
      setSelectedPrograms([]);
      setSource(sourceOptions[0]);
      setApp(appTypeOptions[0]);
      setType(typeOptions[0]);
      setStatus(statusOptions[0]);
    }
  };

  const changeCsvData = (exportData) => {
    const defaultValues = [
      "startBalanceTotal",
      "deposit",
      "reversal",
      "transfer",
      "award",
      "reclaim",
      "endBalanceTotal",
    ];
    exportData.forEach(function (part, index, theArray) {
      for (const element of defaultValues) {
        theArray[index][element] = formatCurrency(theArray[index][element]);
      }
    });

    return exportData;
  };

  const onClickFilterCallback = (values) => {
    let change = false;
    if (options.programs) {
      if (!isEqual(values.programs, previous.programs)) {
        change = true;
      }
    }

    if (options.dateRange) {
      if (finalFilter.from !== values.from || finalFilter.to !== values.to) {
        change = true;
      }
    }
    if (options.keyword) {
      if (finalFilter.keyword !== values.keyword) {
        change = true;
      }
    }
    if (options.source) {
      if (finalFilter.source !== values.source) {
        change = true;
      }
    }
    if (options.app) {
      if (finalFilter.app !== values.app) {
        change = true;
      }
    }
    if (options.type) {
      if (finalFilter.type !== values.type) {
        change = true;
      }
    }
    if (options.status) {
      if (finalFilter.status !== values.status) {
        change = true;
      }
    }

    if (!change) {
      alert("No change in filters");
      setUseFilter(false);
      return;
    }

    let filters = {};
    if (options.keyword) filters.keyword = values.keyword;

    if (options.programs) {
      filters.programs = values.programs;
    }
    if (options.dateRange) {
      filters.from = values.from;
      filters.to = values.to;
    }
    if (options.source) {
      filters.source = values.source;
    }
    if (options.app) {
      filters.app = values.app;
    }
    if (options.type) {
      filters.type = values.type;
    }
    if (options.status) {
      filters.status = values.status;
    }

    filters.programs = filter.programs;
    setFilter(filters);
    setUseFilter(true);
  };


  return (
    <Row className="table-filter-form form">
      <Col md={8} lg={8} sm={8} className="table-filter-form-fields">
        <div className="d-flex flex-wrap">
          {options.programs && (
            <div className="col-md-3 px-0 pr-3 p-2">
              <div>
                <ProgramsHierarchy
                  defaultPrograms={options.programs}
                  selectedPrograms={selectedPrograms}
                  setSelectedPrograms={setSelectedPrograms}
                />
              </div>
            </div>
          )}
          {options.keyword && (
            <>
              <div className="col-md-3 px-0 pr-3 pb-3">
                <span className="form__form-group-label">Search</span>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyDown={handleKeyDown}
                  type="text"
                  placeholder="Search"
                />
              </div>
            </>
          )}
          {options.source && (
            <>
              <div className="col-md-3 px-0 pr-3">
                <span className="form__form-group-label">All Sources</span>
                <Select
                  value={source}
                  onChange={setSource}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="source"
                  options={sourceOptions}
                />
              </div>
            </>
          )}
          {options.app && (
            <>
              <div className="col-md-3 px-0 pr-3">
                <span className="form__form-group-label">All App</span>
                <Select
                  value={app}
                  onChange={setApp}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="source"
                  options={appTypeOptions}
                />
              </div>
            </>
          )}
          {options.type && (
            <>
              <div className="col-md-3 px-0 pr-3">
                <span className="form__form-group-label">All Types: </span>
                <Select
                  value={type}
                  onChange={setType}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="source"
                  options={typeOptions}
                />
              </div>
            </>
          )}
          {options.status && (
            <>
              <div className="col-md-3 px-0 pr-3">
                <span className="form__form-group-label">All Status</span>
                <Select
                  value={status}
                  onChange={setStatus}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="source"
                  options={statusOptions}
                />
              </div>
            </>
          )}
          {options.dateRange && (
            <>
              <div className="col-md-3 px-0 pr-3">
                <span className="form__form-group-label">From</span>
                <DatePicker
                  dateFormat="MM/dd/yyyy"
                  selected={from}
                  onChange={(value) => setFrom(value)}
                />
              </div>
              <div className="col-md-3 px-0 pr-3">
                <span className="form__form-group-label">To</span>
                <DatePicker
                  dateFormat="MM/dd/yyyy"
                  selected={to}
                  onChange={(value) => setTo(value)}
                />
              </div>
            </>
          )}
        </div>
      </Col>
      <Col className="align-items-center max-height-32px pl-1">
        <Button
          onClick={() => onClickFilter()}
          className="btn btn-sm btn-primary"
          color="#ffffff"
        >
          Filter
        </Button>
        <Button
          onClick={() => onClickFilter(true)}
          className="btn btn-sm btn-primary"
          color="#ffffff"
        >
          Reset
        </Button>
        {options.exportToCsv && (
          <div>
            <span
              className="text-blue pointer mr-2"
              onClick={() => {
                download(filter);
              }}
            >
              Export to CSV
            </span>
            <CSVLink
              data={changeCsvData(exportData)}
              headers={exportHeaders}
              filename="report.csv"
              className="hidden"
              ref={exportLink}
              target="_blank"
            />
          </div>
        )}
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    organization: state.organization,
  };
};
export default connect(mapStateToProps)(EmailLogsFilter);
